<!-- @format -->

<template>
  <alert-box
    :alertText="errMsg"
    :alertType="errType"
    ref="alertbox"
  ></alert-box>
  <div>
    <div class="mynavbr">
      <!-- <div class="bar-icon" @click="toggleSideBar()">
        <i class="fa-solid fa-bars-staggered"></i>
      </div> -->
      <div class="title-div">
        <!-- <div class="menubar fas fa-bars" @click="toggleSideBar()">Hello</div> -->
        <div class="logo-div">
          <!-- Logo Change -->
          <!-- <img src="../assets/kdganesha.jpg" class="topbarlogo" /> -->

          <img :src="logoPathVue" class="topbarlogo" />
        </div>

        <!--Title -->
        <router-link to="/" class="title">{{ companyName }}</router-link>
        <!-- {{ ip }} -->
      </div>

      <div class="logout-div">
        <span class="logout" @click="toggleLogout"> Logout </span>
      </div>
    </div>

    <!-- Logout Box -->
    <logout-box
      v-show="logoutbox"
      @cancel="toggleLogout"
      @logout="logoutBtn"
    ></logout-box>
  </div>
</template>

<script>
import LogoutBox from "./LogoutBox.vue";
import axios from "axios";

export default {
  emits: ["toggleBar"],
  components: {
    LogoutBox,
  },
  data() {
    return {
      ip: null,
      // companyName: "Life Kare",
      logoutbox: false,
      userId: this.$store.state.userId,
      userName: this.$store.state.userName,
      branchame: this.$store.state.branchame,
      companyName: this.$store.state.cname,
      logoPathVue: this.$store.state.logoPathVue,
      forceLogoutInterval: null, // Add this line
      pageName: "users.php",
      errMsg: "",
      errType: "",
    };
  },
  methods: {
    toggleLogout() {
      this.logoutbox = !this.logoutbox;
    },

    async logoutBtn() {
      localStorage.clear();
      this.$store.state.isAuthenticated = false;
      this.$router.push("/");
      await axios
        .post(this.pageName, {
          optn: "LogoutTime",
          muserid: this.userId,
        })
        .then(() => {
          // var resp = response.data;
          // console.log("resp", resp);
        });
    },
    toggleSideBar() {
      this.$emit("toggleBar");
    },
    async getLocalIP() {
      try {
        const response = await axios.get("ipfetch.php");
        // console.log("IP Response:", response.data);
        if (response.data && response.data.ip) {
          // console.log(response);
          // this.ip = response.data.ip;
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching IP:", error);
        this.ip = "Unable to fetch IP";
      }
    },
  },
  mounted() {
    // this.getLocalIP();
    // this.forceLogoutInterval = setInterval(this.checkForceLogout, 2000);
  },
  beforeUnmount() {
    if (this.forceLogoutInterval) {
      clearInterval(this.forceLogoutInterval);
    }
  },
};
</script>

<style>
@import "../css/base.css";
</style>

<style scoped>
.mynavbr {
  position: fixed;
  width: 100%;
  top: 0px;
  display: block;
  box-shadow: 0px 1px 8px 2px lightgray;
  text-align: left;
  padding: 0px;
  z-index: 999;
  background-color: white;
}

.topbarlogo {
  height: 35px;
}
.mynavbr .bar-icon {
  cursor: pointer;
  position: relative;
  display: inline-block;
  left: 4px;
  top: -8px;
  padding: 6px;
}

.mynavbr .bar-icon:hover {
  border-radius: 5px;
  background-color: lightgray;
}

.mynavbr .title-div,
.logout-div {
  /* width: calc(50% - 20px); */
  display: inline-block;
  position: relative;
  padding: 6px;
}

.mynavbr .logo-div {
  position: relative;
  display: inline-block;
}

.mynavbr .title-div {
  position: relative;
  text-align: left;
  left: 5px;
}

.mynavbr .title-div .title {
  position: relative;
  left: 8px;
  top: -8px;
  text-decoration: none;
  color: var(--theme-color);
  font-size: 22px;
  font-weight: 600;
}

.mynavbr .logout-div {
  position: relative;
  top: 10px;
  float: right;
  text-align: right;
  right: 10px;
}

.logout {
  font-size: 15px;
  font-weight: 700;
  color: slategray;
  cursor: pointer;
}
.logout:hover {
  color: #2c3e50;
}

.username {
  position: relative;
  color: #2c3e50;
  margin-right: 5px;
}

.fa-bars {
  display: none;
}

@media only screen and (max-width: 600px) {
  .mynavbr .bar-icon {
    left: 4px;
    top: -5px;
  }

  .topbarlogo {
    height: 25px;
  }

  .mynavbr .title-div .title {
    top: -8px;
    font-size: 11px;
    font-weight: 600;
    color: var(--theme-color);
  }

  .logout {
    position: relative;
    top: -5px;
    font-size: 12px;
    font-weight: 600;
  }
}
</style>
